import { onBeforeUnmount } from 'vue'
import type {
  Vue2Component,
  Event,
  Handler,
  Attributes,
  UseFinderOptions
} from './types'
import { loadUIkitComponent } from '@/utils/loadComponent'

function useFinder(finderOptions: UseFinderOptions) {
  const { container, handlers = {} } = finderOptions
  let finder: Vue2Component | undefined

  const open = async (attributes: Attributes) => {
    if (!container.value) {
      throw new Error('Cannot mount vue-finder on null container.')
    }
    const Finder = await loadUIkitComponent('@uikit/vue-finder')
    finder = Finder.default?.create(attributes)
    finder?.$mount(container.value)
    Object.keys(handlers).forEach(event => {
      finder?.$on(event, handlers[event as Event] as Handler)
    })
  }

  const close = () => {
    // 实际无法销毁，只好手动执行 $off
    finder?.$off()
    finder?.$destroy()
  }

  onBeforeUnmount(() => {
    close()
  })

  return { open, close }
}

export default useFinder
